import React, { useRef, useEffect } from 'react';
import { Image as KonvaImage } from 'react-konva';
import Konva from 'konva';
import { useCachedImage } from './useCachedImage';
import 'konva/lib/shapes/Image';
import 'konva/lib/filters/Brighten';
import 'konva/lib/filters/Contrast';
import 'konva/lib/filters/Grayscale';
import 'konva/lib/filters/Sepia';


const BoundImage = ({ shape }) => {
  const image = useCachedImage(shape.boundImage?.imageSrc);
  const imageRef = useRef(null);

  useEffect(() => {
    if (!image || !shape.boundImage || !imageRef.current) return;

    const imgNode = imageRef.current;
    if (image == 'qrcode') return
    imgNode.cache();

    const filters = [];
    const { brightness = 0, contrast = 0, grayscale = 0, sepia = 0 } = shape.boundImage;

    if (brightness !== 0) filters.push(Konva.Filters.Brighten);
    if (contrast !== 0) filters.push(Konva.Filters.Contrast);
    if (grayscale !== 0) filters.push(Konva.Filters.Grayscale);
    if (sepia !== 0) filters.push(Konva.Filters.Sepia);

    imgNode.filters(filters);
    imgNode.brightness(brightness);
    imgNode.contrast(contrast);
    imgNode.grayscale(grayscale);
    imgNode.sepia(sepia);

    imgNode.getLayer()?.batchDraw();
  }, [image, shape.boundImage]);


  if (!image || !shape.boundImage) return null;

  const { fitMode = 'fit' } = shape.boundImage;
  const { x, y, width, height } = shape;

  let imgWidth = image.width;
  let imgHeight = image.height;

  let scaleX = 1;
  let scaleY = 1;
  let offsetX = 0;
  let offsetY = 0;

  if (fitMode === 'fit') {
    const scale = Math.min(width / imgWidth, height / imgHeight);
    scaleX = scaleY = scale;
    offsetX = (width - imgWidth * scale) / 2;
    offsetY = (height - imgHeight * scale) / 2;
  } else if (fitMode === 'cover') {
    const scale = Math.max(width / imgWidth, height / imgHeight);
    scaleX = scaleY = scale;
    offsetX = (width - imgWidth * scale) / 2;
    offsetY = (height - imgHeight * scale) / 2;
  } else {
    // stretch
    scaleX = width / imgWidth;
    scaleY = height / imgHeight;
  }

  return (
    <KonvaImage
      ref={imageRef}
      image={image}
      x={x + offsetX}
      y={y + offsetY}
      scaleX={scaleX}
      scaleY={scaleY}
      width={imgWidth}
      height={imgHeight}
      listening={false}
    />
  );
};

export default BoundImage;
